"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetStoreOnUnMount = void 0;
var react_1 = require("react");
var mp_context_1 = require("../context/mp-context");
var useResetStoreOnUnMount = function () {
    var mpStore = (0, mp_context_1.useMpContext)().mpStore;
    (0, react_1.useEffect)(function () {
        return function () { return mpStore.reset(); };
    }, [mpStore]);
};
exports.useResetStoreOnUnMount = useResetStoreOnUnMount;
